import React from 'react';
export function NotAccess() {

    return (
        <>           
            <div>Нет доступа</div>
        </>
    );
}